import { EntityData } from "@/components/TriggerSetup/logic/types/entity-data.type";
import { baseCondition } from "@/components/TriggerSetup/logic/structures/base-condition.structure";
import { TriggerCondition } from "@/components/TriggerSetup/logic/types/types";
import WorkTimeSetupView from "@/components/TriggerSetup/conditions/WorkTime/WorkTimeSetupView.vue";
import { snakeCase } from "lodash";
import { getTagsByFieldKey } from '@/mixins/TariffsTagsHelper'

const condition: () => EntityData = () => {
  return {
    'setupView': WorkTimeSetupView,
    'structure': {
      'type': 'WorkTime',
      ...baseCondition,
    } as TriggerCondition,
    'titleKey': `trigger_condition_${ snakeCase('WorkTime') }`,
    'limited': getTagsByFieldKey('WorkTimeCondition'),
  }
}

export default condition
